import React from 'react';
import styles from '../Operations.module.css';

interface OATTComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const OATT: OATTComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        Attachment rate is calculating the number of transactions where corresponding or complimenting items are sold with the primary product. For instance, what percent of grill transactions include a cover, sauces, rubs or fuel.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        Overall attachment is measuring the combined attachment for Paint, Grills and Power Tools.
        <br /><br />
        Merchandise Classes used in Attachment Rate:
        <br />
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Category</th>
              <th>Transaction In</th>
              <th>Attach</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Paint</td>
              <td>MCs 161, 162</td>
              <td>MCs 126, 131, 171</td>
            </tr>
            <tr>
              <td>Grills</td>
              <td>MC 868</td>
              <td>MCs 870, 873, and 869 (PGs, 01 - 04, 07 &amp; 09)</td>
            </tr>
            <tr>
              <td>Power Tools</td>
              <td>MCs 285, 286</td>
              <td>MCs 205, 225, 235, 247, 251, 252, 287</td>
            </tr>
            <tr>
              <td>Single SKU</td>
              <td>All</td>
              <td>Single SKU Transactions</td>
            </tr>
          </tbody>
        </table>
        Note: Unrecognized/Non Ace SKUs or SKUs not passing the ADW Business rules will not be included. For instance, if the SKU sold for far less than the shelf price, this SKU would be excluded from the calculation.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        45%
        <br /><br />
        <strong><u>Drilldown</u></strong>
        <br />
        Clicking the Attachment Rate Link will bring up the Attachment Rate Report showing the focus categories: Paint, Grills and Power Tools. Each category will show attachment for last week (Monday thru Sunday), year to date (YTD) and Rolling 12 (RO12).
        <br /><br />
       Update Cadence: Metric is monthly, but drilldown detail is weekly.
       
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        See Ace Way of Retailing (AWOR) Deliver an Amazing Customer Experience Store Procedures document for instructions on how to deliver on the helpful promise in your store.
      </div>
    </div>
  );
};



OATT.title = 'Attachment Rate';
OATT.actionTitle = 'Review Last Week & Ytd';
OATT.actionHyperlink = 'dynamicURL:WFC:current';
export default OATT;

